module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAoCAYAAACFFRgXAAAAj0lEQVRYR+3YwQmAMAyF4WQEl+vBiRxI0DlcQDfRe+jxPSHwO8Br+Axt2nyO8UajLynY/LcQNgMHwnbha18X9yLK/FSG/ZFFwW5lhBEuArSEvSXuc2zuRZT5zBJKzVkWwgjXfbjdJbTdtubuOXU+R7NatOYhjDDzsLsHqnC7h5R2RzMFm3uaAd4MzIO2Gzg+3oZDZUhZNugAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu.png
// module id = 01ru
// module chunks = 34